module.exports = "../images/fishing-lodge-10.jpg?v=8cff095";